import React from 'react';
import {
    Box,
    Typography,
    FormGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    MenuItem,
    Paper
} from '@mui/material';
import { ProjectProcessHeader } from '../../projectProcess/ProjectProcessApiClient';
import { Localized } from '@fluent/react';

interface CustomMMReportOptionsProps {
    selectedStatuses: string[];
    setSelectedStatuses: (statuses: string[]) => void;
    selectedPriorities: string[];
    setSelectedPriorities: (priorities: string[]) => void;
    selectedProcess: string;
    setSelectedProcess: (process: string) => void;
    onlyCurrentMeeting: boolean;
    setOnlyCurrentMeeting: (value: boolean) => void;
    includeFullItemsHistory: boolean;
    setIncludeFullItemsHistory: (value: boolean) => void;
    processesList: ProjectProcessHeader[];

}

const ITEM_STATUSES = [
    { value: 'NEW', labelId: 'meeting-minutes-status-new', defaultLabel: 'Nowe' },
    { value: 'ACTIVE', labelId: 'meeting-minutes-status-active', defaultLabel: 'W trakcie' },
    { value: 'FINISHED', labelId: 'meeting-minutes-status-finished', defaultLabel: 'Zakończone' },
    { value: 'CANCELED', labelId: 'meeting-minutes-status-canceled', defaultLabel: 'Anulowane' }
];

const ITEM_PRIORITIES = [
    { value: 'L', labelId: 'priority.L', defaultLabel: 'Niski' },
    { value: 'M', labelId: 'priority.M', defaultLabel: 'Normalny' },
    { value: 'H', labelId: 'priority.H', defaultLabel: 'Wysoki' }
];

export const CustomMMReportOptions: React.FC<CustomMMReportOptionsProps> = ({
    selectedStatuses,
    setSelectedStatuses,
    selectedPriorities,
    setSelectedPriorities,
    selectedProcess,
    setSelectedProcess,
    processesList,
    onlyCurrentMeeting,
    setOnlyCurrentMeeting,
    includeFullItemsHistory,
    setIncludeFullItemsHistory
}) => {

    const toggleSelection = (
        value: string,
        list: string[],
        setList: (updated: string[]) => void
    ) => {
        setList(list.includes(value) ? list.filter((v) => v !== value) : [...list, value]);
    };

    return (
        <Box display="flex" flexDirection="column" gap={3}>
            <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                    Ogólne parametry
                </Typography>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={onlyCurrentMeeting}
                                onChange={(e) => setOnlyCurrentMeeting(e.target.checked)}
                            />
                        }
                        label="Tematy tylko z bieżącego spotkanie"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={includeFullItemsHistory}
                                onChange={(e) => setIncludeFullItemsHistory(e.target.checked)}
                            />
                        }
                        label="Pełna historia statusów zadań"
                    />
                </FormGroup>
            </Paper>
            {/* Filtr procesu – pod spodem pełna szerokość */}
            <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                    Filtr procesu
                </Typography>
                <TextField
                    select
                    fullWidth
                    size="small"
                    value={selectedProcess}
                    onChange={(e) => setSelectedProcess(e.target.value)}
                >
                    <MenuItem value="">-- Wybierz proces --</MenuItem>
                    {processesList.map((p) => (
                        <MenuItem key={p.id} value={p.id}>
                            {p.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Paper>
            {/* Statusy i Priorytety obok siebie */}
            <Box display="flex" gap={2} flexWrap="wrap">

                {/* Statusy */}
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, flex: 1, minWidth: 250 }}>
                    <Typography variant="subtitle1" gutterBottom>
                        Statusy tematów/zadań
                    </Typography>
                    <FormGroup>
                        {ITEM_STATUSES.map(({ value, labelId, defaultLabel }) => (
                            <FormControlLabel
                                key={value}
                                control={
                                    <Checkbox
                                        checked={selectedStatuses.includes(value)}
                                        onChange={() => toggleSelection(value, selectedStatuses, setSelectedStatuses)}
                                    />
                                }
                                label={<Localized id={labelId}><span>{defaultLabel}</span></Localized>}
                            />
                        ))}
                    </FormGroup>
                </Paper>

                {/* Priorytety */}
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, flex: 1, minWidth: 250 }}>
                    <Typography variant="subtitle1" gutterBottom>
                        Priorytety tematów/zadań
                    </Typography>
                    <FormGroup>
                        {ITEM_PRIORITIES.map(({ value, labelId, defaultLabel }) => (
                            <FormControlLabel
                                key={value}
                                control={
                                    <Checkbox
                                        checked={selectedPriorities.includes(value)}
                                        onChange={() => toggleSelection(value, selectedPriorities, setSelectedPriorities)}
                                    />
                                }
                                label={<Localized id={labelId}><span>{defaultLabel}</span></Localized>}
                            />
                        ))}
                    </FormGroup>
                </Paper>
            </Box>


        </Box>
    );
};
